/**
 * Results Index Route
 * Redirects /results → /results/pc
 *
 * Authentication is handled by the parent _protected layout route.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/results/')({
  beforeLoad: () => {
    throw redirect({ to: '/results/pc' });
  },
});
